import Component from './src/table.vue';

Component.install = function install(_Vue) {
  _Vue.component(Component.name, Component);
};

export default Component;
